import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

import { TripFull } from '@/models/trip'
import { DamageReport, DamageReportStatus } from '@/models/damageReport'

import { normalizeUserName } from '@/helpers/user'

interface Props {
  trip: TripFull
  report: DamageReport
  isResolving: boolean
  editable?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DamageReportItem',
  props: {
    trip: {},
    report: {},
    isResolving: { type: Boolean },
    editable: { type: Boolean, default: true }
  },
  emits: ["resolve"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const handleResolveConfirm = () => {
  emit('resolve', props.trip.id, props.report.id)
}

const imageUrls = computed(() =>
  props.report.images.map(({ secure_url }) => secure_url)
)

const isHost = computed(() => props.trip.host_id === props.report.user_id)

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!

  return (_openBlock(), _createBlock(_component_el_descriptions, {
    border: "",
    column: 2,
    title: `Damage report: ${_ctx.report.id}`,
    direction: "vertical",
    class: "description-container"
  }, {
    extra: _withCtx(() => [
      (_ctx.report.status === _unref(DamageReportStatus).OPENED)
        ? (_openBlock(), _createBlock(_component_el_popconfirm, {
            key: 0,
            title: "Are you sure you want to resolve the damage report?",
            confirmButtonText: "Resolve",
            cancelButtonText: "Cancel",
            onConfirm: handleResolveConfirm
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                plain: "",
                loading: _ctx.isResolving,
                disabled: !_ctx.editable
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" Resolve ")
                ])),
                _: 1,
                __: [0]
              }, 8, ["loading", "disabled"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_descriptions_item, { width: 270 }, {
        label: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("Status")
        ])),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_ctx.report.status), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Description")
        ])),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_ctx.report.description), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, { width: 270 }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(isHost.value ? 'Host' : 'Renter'), 1)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_unref(normalizeUserName)(isHost.value ? _ctx.trip.host : _ctx.trip.renter)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("Images")
        ])),
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 14 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageUrls.value, (url) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  key: url,
                  xs: 12,
                  sm: 12,
                  md: 4,
                  lg: 4,
                  xl: 4
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, {
                      class: "image-container",
                      src: url,
                      "preview-src-list": imageUrls.value
                    }, null, 8, ["src", "preview-src-list"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})